import React, { Component } from 'react';
import { Modal, Select, message } from 'antd';
const Option = Select.Option;

/**
 * 角色选取列表，选择某个角色，然后返回
 */
class RoleSelectionModal extends Component {
    state = {
        value: undefined,
        roles: [],
    }

    show = (roles, investigation) => {
        this.setState({
            roles,
            investigation,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            value: undefined,
        });
    }

    handleSelectRole = value => {
        this.setState({ value });
    }

    handleSubmit = () => {
        const { value, roles, investigation } = this.state;
        if (!value) {
            message.warning('请选择角色');
            return;
        }
        this.props.selectRole(value, roles, investigation);
        this.hide();
    };

    render() {
        const { visible, roles, value } = this.state;
        const rolesOption =  roles.map(el => {
            let text = '';
            if (el === 'TAL') {
                text = '领域leader';
            } else if (el === 'KAM') {
                text = '大客户经理';
            } else {
                text = el;
            }
            return {
                value: el,
                label: text,
            }
        })
        return (
            <Modal
                title='选择角色'
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                maskClosable={false}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">角色:</div>
                            <div className="item-right">
                                <Select value={ value } style={{width: 120}} placeholder="请选择" onChange={this.handleSelectRole}>
                                    {/* {roles.map(d => <Option key={d}>{d === 'TAL' ? '领域leader' : d}</Option>)}
                                     */}
                                    {rolesOption.map(el => <Option key={el.value}>{el.label}</Option>)}
                                </Select>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    };
}

export default RoleSelectionModal;



// WEBPACK FOOTER //
// ./src/components/investigation/RoleSelectionModal.js